import {
    ClickAwayListener,
    Divider,
    FormControl,
    Zoom,
    InputLabel,
    TextField,
    Typography,
    Box,
    FormGroup,
    FormControlLabel,
    Switch,
} from "@material-ui/core";
import { LocalizationProvider, MobileDatePicker } from "@material-ui/lab";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import TuneIcon from "@material-ui/icons/Tune";
import CustomButton from "../../controls/Button/CustomButton";




const ShowPeriodFilterParameter = ({ dateStart, dateEnd, setDateStart, setDateEnd, openPicker, setOpenPicker, classes, filterTypes, switchState, handleChangeFilter }) => {

    const handleClick = () => {
        setOpenPicker(prev => !prev);
    };

    const handleClickAway = () => {
        setOpenPicker(false);
    };

    return (
        <ClickAwayListener
            mouseEvent="onMouseDown"
            touchEvent="onTouchStart"
            onClickAway={handleClickAway}
        >
            <Box style={{ position: "relative", marginRight: "12%" }}>
                <CustomButton
                    onClick={handleClick}
                    style={{ fontSize: "13px" }}
                    customClass={`${classes.customHeaderBtn} ${classes.btnFilterAppointment}`}
                    icon={
                        <TuneIcon
                            style={{ marginRight: "5px" }}
                            className={classes.iconFilter}
                        />
                    }
                />

                {openPicker && (
                    <Zoom in={openPicker}>
                        <Box className={`${classes.dropDownMyHistory} ${classes.dropdown}`}>
                            <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                PERIODO
                            </Typography>
                            <Divider classes={{ root: classes.dividerFilter }} />
                            <Box className={`${classes.headerFiltro} ${classes.marginTop}`}>
                                <FormControl className={`${classes.datePicker} ${classes.filterStart}`}>
                                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink>
                                        DESDE
                                    </InputLabel>
                                    <Box className={classes.top22} style={{ display: "flex", justifyContent: "space-between" }}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <MobileDatePicker
                                                cancelText="Cancelar"
                                                toolbarTitle=""
                                                inputFormat="dd/MM/yyyy"
                                                value={dateStart}
                                                maxDate={dateEnd}
                                                onChange={newValue => setDateStart(newValue)}
                                                renderInput={params => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                        <CalendarTodayIcon style={{ alignSelf: "center" }} />
                                    </Box>
                                </FormControl>
                                <FormControl className={`${classes.datePicker} ${classes.filterEnd}`}>
                                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink>
                                        HASTA
                                    </InputLabel>
                                    <Box className={classes.top22} style={{ display: "flex", justifyContent: "space-between" }}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <MobileDatePicker
                                                cancelText="Cancelar"
                                                toolbarTitle=""
                                                inputFormat="dd/MM/yyyy"
                                                value={dateEnd}
                                                minDate={dateStart}
                                                onChange={newValue => setDateEnd(newValue)}
                                                renderInput={params => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                        <CalendarTodayIcon style={{ alignSelf: "center" }} />
                                    </Box>
                                </FormControl>
                            </Box>
                            <Box style={{ marginTop: "20px" }}>
                                <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                    PARAMETRO
                                </Typography>

                                <Divider classes={{ root: classes.dividerFilter }} />
                                <FormControl component="fieldset" className={`${classes.formControl} ${classes.formSwitch}`}>
                                    <FormGroup>
                                        {filterTypes.map((val, index) => (
                                            <FormControlLabel
                                                key={index}
                                                className={classes.marginRight}
                                                labelPlacement="start"
                                                control={
                                                    <Switch
                                                        onChange={handleChangeFilter}
                                                        color="primary"
                                                        name={val}
                                                        checked={switchState[val]}
                                                    />
                                                }
                                                label={
                                                    <Typography className={`${classes.txtFilter} ${classes.txtEllipsis}`}>
                                                        {val}
                                                    </Typography>
                                                }
                                            />
                                        ))}
                                    </FormGroup>
                                </FormControl>
                            </Box>
                        </Box>
                    </Zoom>
                )}
            </Box>
        </ClickAwayListener>
    );
};

export default ShowPeriodFilterParameter;
